module.exports = __webpack_public_path__ + "img/card-blog2.f9e9828f.jpg";